import CreateStoreStore from './CreateStoreStore'

export default CreateStoreStore
